import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as actions from './redux/actions';
import LazyLoad from 'react-lazyload';
import Landing from '../landing/LandingLoadable';
import Framing from '../framing/FramingLoadable';
import Section1 from '../section-1/Section1Loadable';
import Gifts from '../gifts/GiftsLoadable';
import Holidays from '../holidays/HolidaysLoadable';
import Pond from '../pond/PondLoadable';
import Contact from '../contact/ContactLoadable';
import Footer from '../footer/FooterLoadable';

export class DefaultPage extends PureComponent {
  static propTypes = {
    home: PropTypes.object.isRequired,
    actions: PropTypes.object.isRequired,
  };

  render() {
    const spinner = document.getElementById('spinner');

    if (spinner && !spinner.hasAttribute('hidden')) {
      spinner.setAttribute('hidden', 'true');
    }
    return (
      <div id="home" className="home-default-page">
        <Landing />
        <Framing />
        <LazyLoad height={'100vh'} offset={200}>
          <Section1 />
        </LazyLoad>
        <Gifts />
        <Holidays />
        <Pond />
        <Contact />
        <LazyLoad height={85} offset={200}>
          <Footer />
        </LazyLoad>
      </div>
    );
  }
}

/* istanbul ignore next */
function mapStateToProps(state) {
  return {
    home: state.home,
  };
}

/* istanbul ignore next */
function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({ ...actions }, dispatch),
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(DefaultPage);



// WEBPACK FOOTER //
// ./src/features/home/DefaultPage.js